import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

const realisation = new PhotoSwipeLightbox({
	gallery: '.realisations-gallery',
	bgOpacity: 0.85,
	children: 'a',
	showHideAnimationType: 'fade',
	zoomAnimationDuration: false,
	showAnimationDuration: 250,
	hideAnimationDuration: 250,
	pswpModule: () => import('photoswipe')
});

// Fix pour utilisation de thumbnail n'ayant pas les mêmes ratio que les grandes images
realisation.addFilter('useContentPlaceholder', (useContentPlaceholder, content) => { return false; });

realisation.init();

const produit = new PhotoSwipeLightbox({
	gallery: '.produit-gallery',
	bgOpacity: 0.85,
	children: 'a',
	showHideAnimationType: 'fade',
	zoomAnimationDuration: false,
	showAnimationDuration: 250,
	hideAnimationDuration: 250,
	pswpModule: () => import('photoswipe')
});

// Fix pour utilisation de thumbnail n'ayant pas les mêmes ratio que les grandes images
produit.addFilter('useContentPlaceholder', (useContentPlaceholder, content) => { return false; });

produit.init();